module.exports = __webpack_public_path__ + "static/media/cloudrug.20883053.webp";